const CustomerAccountType = Object.freeze({
    PERSONAL: 'personal',
    BUSINESS: 'business',
});

module.exports = CustomerAccountType;
